import React, { useState, useEffect } from 'react';
import Color from 'color';
import IconHamburger from 'cccisd-icons/menu7';
import RenderInBody from 'cccisd-render-in-body';
import NavItem from '../NavItem';
import style from './style.css';

const MobileNav = ({ links }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [isTriggerTransparent, setIsTriggerTransparent] = useState(false);

    const bgRgb = Color(style.cvNavBackground).rgb().color;
    const cvNavBackgroundTransparent = Color.rgb(bgRgb[0], bgRgb[1], bgRgb[2], 0.8);

    function checkTriggerTransparent() {
        if (window.scrollY > 50 && !isTriggerTransparent) {
            // Adjust '50' to your desired scroll point
            setIsTriggerTransparent(true);
        } else if (window.scrollY <= 50 && isTriggerTransparent) {
            setIsTriggerTransparent(false);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', checkTriggerTransparent);
        return () => window.removeEventListener('scroll', checkTriggerTransparent);
    }, [isTriggerTransparent]);

    useEffect(() => {
        if (!isVisible && isTransitioning) {
            setTimeout(() => setIsTransitioning(false), 275);
        }
    }, [isVisible]);

    function handleClickOutside(event) {
        if (event.target.isSameNode(event.currentTarget)) {
            setIsVisible(false);
        }
    }

    function handleClickHamburger() {
        setIsVisible(true);
        setIsTransitioning(true);
    }

    return (
        <>
            <div
                className={style.trigger}
                style={{ backgroundColor: isTriggerTransparent ? cvNavBackgroundTransparent : style.cvNavBackground }}
            >
                <button onClick={handleClickHamburger} type="button">
                    <IconHamburger />
                </button>
            </div>
            <RenderInBody>
                <div
                    className={style.menuContainer}
                    style={{
                        width: isTransitioning ? '100vw' : '0vw',
                        backgroundColor: isVisible ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0)',
                    }}
                    onClick={handleClickOutside}
                >
                    <ul className={'list-unstyled ' + style.menu} style={{ width: isVisible ? '220px' : '0px' }}>
                        {links.map(link => (
                            <NavItem {...link} key={link.to + link.label} />
                        ))}
                    </ul>
                </div>
            </RenderInBody>
        </>
    );
};

export default MobileNav;
